export default __webpack_public_path__ + "static/media/Shaka_particle_final_02.ddb8658e.png";